import { User } from "../types";
import decode from "jwt-decode";
import { ID_TOKEN, ACCESS_TOKEN } from "@constants";
import { GoogleLoginResponse } from "react-google-login";

export function getUserFromSessionStorage(): User | null {
  const id_token = sessionStorage.getItem(ID_TOKEN);
  const access_token = sessionStorage.getItem(ACCESS_TOKEN);

  if (id_token && access_token) {
    try {
      const date = new Date();
      const { sub: id, name, email, picture: avatar, exp } = decode(id_token);

      return exp * 1000 - date.getTime() > 0
        ? {
            id,
            name,
            email,
            avatar,
            id_token,
            access_token,
          }
        : null;
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.log("There was a problem decoding user token", error);
      }
    }
  }

  return null;
}

export function getUserFromGoogleLoginResponse(
  response: GoogleLoginResponse
): User {
  const { profileObj: profile, tokenObj: token } = response;
  const { googleId: id, name, email, imageUrl: avatar } = profile;
  const { id_token, access_token } = token;

  return {
    id,
    name,
    email,
    avatar,
    id_token,
    access_token,
  };
}
